/* eslint-disable*/

const isServer = typeof window === 'undefined'

class PreventScrollChain {
  constructor(elem) {
    if (isServer) return

    this.supportsPassive = false
    try {
      let opts = {}
      Object.defineProperty(opts, 'passive', {
        get: () => {
          this.supportsPassive = true
        }
      })
      window.addEventListener('test', null, opts)
    } catch (e) {}

    if (elem) {
      this.elem = elem
      this.bindEvents.call(this)
    } else {
      console.info('bind events error!, elem not exit!')
    }
  }

  bindEvents() {
    const { elem } = this

    this.touchStart = this._touchStart.bind(this)
    this.touchMove = this._touchMove.bind(this)
    this.mouseWheel = this._mouseWheel.bind(this)

    this.eventOptions = this.supportsPassive
      ? {
          passive: false
        }
      : false

    elem.addEventListener('touchstart', this.touchStart)
    elem.addEventListener('touchmove', this.touchMove, this.eventOptions)
    // wheel mousewheel DOMMouseScroll
    elem.addEventListener('mousewheel', this.mouseWheel)

    console.info('bind events success!')
  }

  _touchStart(event) {
    this.startY = event.changedTouches[0].clientY
  }

  _touchMove(event) {
    const { changedTouches } = event
    if (!changedTouches.length) return

    const touch = changedTouches[0]
    // 根据 deltaY 判断方向，如果大于0代表向下滑动，反之代表向上
    this.deltaY = touch.clientY - this.startY

    const { elem } = this
    const offsetHeight = elem.offsetHeight
    const scrollHeight = elem.scrollHeight
    const scrollTop = elem.scrollTop

    if (event.cancelable) {
      if (this.deltaY > 0 && scrollTop <= 0) {
        // 滑动到弹窗顶部临界条件
        console.info('页面向下滑动')
        event.preventDefault()
        event.stopPropagation()
      } else if (this.deltaY < 0 && scrollTop + offsetHeight >= scrollHeight) {
        // 滑动到底部临界条件
        console.info('页面向上滑动')
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }

  _mouseWheel(event) {
    if (event.wheelDelta) {
      const { elem } = this
      const offsetHeight = elem.offsetHeight
      const scrollHeight = elem.scrollHeight
      const scrollTop = elem.scrollTop

      if (event.wheelDelta > 0 && scrollTop <= 0) {
        console.info('==页面向下滚动')
        event.preventDefault()
        event.stopPropagation()
      } else if (
        event.wheelDelta < 0 &&
        scrollTop + offsetHeight >= scrollHeight
      ) {
        console.info('==页面向上滚动')
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }

  destory() {
    const { elem } = this
    elem.removeEventListener('touchstart', this.touchStart)
    elem.removeEventListener('touchmove', this.touchMove, this.eventOptions)
    // wheel mousewheel DOMMouseScroll
    elem.removeEventListener('mousewheel', this.mouseWheel)
    console.info('bind events destory!')
  }
}

let instance = null

function preventScrollChain(params) {
  // 这里不要使用单例模式！！
  instance = new PreventScrollChain(params)
  return instance
}

preventScrollChain.destory = function () {
  instance && instance.destory()
}

export default preventScrollChain
